import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPanelOptions } from '@reducers/options/panel/actions';
import { APP_TYPES, defaultUnits } from '@config';
import { APP_TEXTS } from '@texts';
import Input from '@components/Input';
import './styles.scss';
import EdgeDistance from '../BasePlate/EdgeDistance';
import { unitTransform } from '@services/helper.service';

class WoodConnectionBracket extends Component {
 
  handleDimensionChange = (field, value) => {
    const newOptions = {
      ...this.props.bracket,
      dimensions: {
        ...this.props.bracket.dimensions,
        [field]: unitTransform(Number(value), false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    };
    this.props.setPanelOptions(newOptions);
  };

  handleThicknessChange = (field, value) => {
    const newOptions = {
      ...this.props.bracket,
      thickness: {
        ...this.props.bracket.thickness,
        [field]: unitTransform(Number(value), false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    };
    this.props.setPanelOptions(newOptions);
  };

  render() {
    const { dimensions, thickness } = this.props.bracket;
    return (
      <React.Fragment>
        <section className="list-type">
          <h6 className="font-weight-bold mb-2">{APP_TEXTS.WOOD_CONNECTION_BRACKET_BASE_PLATE.Content}</h6>
          <div className="dimension-container">
            <Input
              id="dimension-a"
              type="number"
              value={unitTransform(dimensions.a).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
              onUpdate={(value) => this.handleDimensionChange('a', value)}
              prefix={`${APP_TEXTS.WOOD_CONNECTION_BRACKET_DIM_A.Content} =`}
              postfix={this.props.distanceUnit}
              className="mb-2"
            />
            <Input
              id="dimension-b"
              type="number"
              value={unitTransform(dimensions.b).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
              onUpdate={(value) => this.handleDimensionChange('b', value)}
              prefix={`${APP_TEXTS.WOOD_CONNECTION_BRACKET_DIM_B.Content} =`}
              postfix={this.props.distanceUnit}
              className="mb-2"
            />
            <Input
              id="dimension-c"
              type="number"
              value={unitTransform(dimensions.c).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
              onUpdate={(value) => this.handleDimensionChange('c', value)}
              prefix={`${APP_TEXTS.WOOD_CONNECTION_BRACKET_DIM_C.Content} =`}
              postfix={this.props.distanceUnit}
              className="mb-2"
            />
            <Input
              id="dimension-d"
              type="number"
              value={unitTransform(dimensions.d).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
              onUpdate={(value) => this.handleDimensionChange('d', value)}
              prefix={`${APP_TEXTS.WOOD_CONNECTION_BRACKET_DIM_D.Content} =`}
              postfix={this.props.distanceUnit}
              className="mb-2"
            />
          </div>
        </section>
        <section className="list-type">
          <h6 className="font-weight-bold mb-2">{APP_TEXTS.WOOD_CONNECTION_BRACKET_THICKNESS.Content}</h6>
          <Input
            id="thickness-tfixA"
            type="number"
            value={unitTransform(thickness.tfixA).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
            onUpdate={(value) => this.handleThicknessChange("tfixA", value)}
            prefix={<span>t<sub>fix,A</sub> =</span>}
            postfix={this.props.distanceUnit}
          />
          <Input
            id="thickness-tfixB"
            type="number"
            value={unitTransform(thickness.tfixB).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
            onUpdate={(value) => this.handleThicknessChange("tfixB", value)}
            prefix={<span>t<sub>fix,B</sub> =</span>}
            postfix={this.props.distanceUnit}
          />
        </section>
        <section className="list-type">
          <h4>{APP_TEXTS.BASE_PLATE_EDGE_DISTANCE_LABEL.Content}</h4>

          <EdgeDistance />
        </section>
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => ({
  bracket: state.dimension[APP_TYPES.WOOD_CONNECTION].bracket,
  distanceUnit: state.main.units.distance
});

export default connect(mapStateToProps, { setPanelOptions })(WoodConnectionBracket);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/WoodConnectionBracket/WoodConnectionBracket.js